import { Tooltip } from 'antd';
import { Box } from '@mui/material';

const ExitIcon = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path d="M12 4L4 12" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M4 4L12 12" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const ExitButton = ({ handleClose, color = '#ffde21' }) => {
	return (
		<Tooltip title="Exit">
			<Box
				onClick={handleClose}
				sx={{
					width: '22px',
					height: '22px',
					display: 'flex',
					cursor: 'pointer',
					borderRadius: '4px',
					alignItems: 'center',
					transition: 'all 0.3s',
					justifyContent: 'center',

					'&:hover': {
						transform: 'scale(1.2)',
					},
				}}
			>
				<ExitIcon color={color} />
			</Box>
		</Tooltip>
	);
};

export default ExitButton;
